import React, { useEffect, useState } from 'react';
import { useApi } from '@/contexts/AuthContext';
import { CheckCircle2 } from 'lucide-react';

const C = { navy: '#0D1B2A', slate: '#5C6B7A', line: '#E4E9EF', blue: '#2A6FC4', orange: '#E07A2F' };

export default function CarrierProfilesPage() {
  const api = useApi();
  const [carriers, setCarriers] = useState([]);
  const [open, setOpen] = useState('iag');

  useEffect(() => {
    api.get('/market-intel/carriers').then(r => setCarriers(r.data.items || [])).catch(() => {});
  }, [api]);

  return (
    <div className="space-y-4" data-testid="carrier-profiles-page">
      <p className="text-xs" style={{ color: C.slate }}>
        Figures and derived analysis only — no carrier prose is stored. Every figure carries its source, as-at date and verified flag. Next refresh cycle: February 2027 (results season).
      </p>
      {carriers.map(c => (
        <div key={c.carrier_id} className="rounded-lg border bg-white overflow-hidden" style={{ borderColor: C.line }} data-testid={`carrier-${c.carrier_id}`}>
          <button onClick={() => setOpen(open === c.carrier_id ? null : c.carrier_id)}
            className="w-full flex items-center justify-between px-4 py-3 text-left hover:bg-[#F8FAFC]"
            data-testid={`carrier-toggle-${c.carrier_id}`}>
            <div className="flex items-baseline gap-3">
              <span className="text-sm font-bold" style={{ color: C.navy }}>{c.name}</span>
              <span className="text-[10px] font-mono" style={{ color: C.slate }}>{c.ticker}</span>
              <span className="text-[10px] px-2 py-0.5 rounded" style={{ background: '#F0F4F8', color: C.slate }}>{c.basis} · as at {c.as_at}</span>
            </div>
            <span className="text-xs" style={{ color: C.blue }}>{open === c.carrier_id ? 'collapse' : 'expand'}</span>
          </button>
          {open === c.carrier_id && (
            <div className="px-4 pb-4 space-y-3">
              <p className="text-xs italic" style={{ color: C.navy }}>{c.why_it_matters}</p>
              <table className="w-full text-xs">
                <thead><tr style={{ color: C.slate }}>
                  <th className="text-left py-1 font-semibold uppercase text-[9px] tracking-wider w-1/3">Figure</th>
                  <th className="text-left py-1 font-semibold uppercase text-[9px] tracking-wider">Value</th>
                  <th className="text-left py-1 font-semibold uppercase text-[9px] tracking-wider w-44">Source · as at</th>
                  <th className="w-8" />
                </tr></thead>
                <tbody>
                  {(c.figures || []).map((f, i) => (
                    <tr key={i} className="border-t" style={{ borderColor: '#F0F2F5' }}>
                      <td className="py-1.5 pr-2" style={{ color: C.slate }}>{f.label}</td>
                      <td className="py-1.5 pr-2 font-medium" style={{ color: C.navy }}>{f.value}</td>
                      <td className="py-1.5 pr-2 text-[10px]" style={{ color: C.slate }}>{f.source} · {f.as_at}</td>
                      <td className="py-1.5">{f.verified && <CheckCircle2 size={13} style={{ color: '#1B7A3D' }} data-testid={`verified-${c.carrier_id}-${i}`} />}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
              <div className="grid sm:grid-cols-2 gap-3 text-xs">
                <div className="p-3 rounded" style={{ background: '#F8FAFC' }}>
                  <p className="text-[9px] uppercase tracking-wider font-semibold mb-1" style={{ color: C.slate }}>Delegated / distribution posture</p>
                  <p style={{ color: C.navy }}>{c.delegated_posture}</p>
                </div>
                <div className="p-3 rounded" style={{ background: '#FFF7F0' }}>
                  <p className="text-[9px] uppercase tracking-wider font-semibold mb-1" style={{ color: C.orange }}>Key read</p>
                  <p style={{ color: C.navy }}>{c.key_read}</p>
                </div>
              </div>
            </div>
          )}
        </div>
      ))}
    </div>
  );
}
